import gsap from 'gsap';
import { ScrollTrigger, Power2 } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);


(function ($) {

    const dotsParallax = $('.careers-home__dots');
    if (dotsParallax) {
        ScrollTrigger.matchMedia({
            "(max-width: 766px)": function () {
                gsap.set(dotsParallax, {
                    clearProps: 'all'
                })
            },
            "(min-width: 766px)": function () {
                gsap.fromTo(dotsParallax, {
                    y: '-5%'
                }, {
                    y: '15%',
                    scrollTrigger: {
                        trigger: dotsParallax,
                        start: 'top bottom',
                        end: 'bottom top',
                        scrub: 1,
                    }
                })

                ScrollTrigger.addEventListener("refreshInit", () => {
                    gsap.set(dotsParallax, {
                        clearProps: 'x'
                    })
                });
            }
        })
    }

})(jQuery);